"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.6356 12.4062C16.3178 12.4062 16.9182 12.0332 17.2275 11.4692L20.4841 5.56552C20.8206 4.96514 20.384 4.21922 19.6927 4.21922H6.22969L5.37461 2.3999H2.40002V4.21922H4.21934L7.49412 11.1235L6.26608 13.3431C5.60203 14.5621 6.4753 16.0448 7.85798 16.0448H18.7739V14.2255H7.85798L8.85861 12.4062H15.6356ZM7.09387 6.03854H18.1462L15.6356 10.5868H9.24976L7.09387 6.03854ZM7.85798 16.9545C6.85736 16.9545 6.04776 17.7732 6.04776 18.7738C6.04776 19.7744 6.85736 20.5931 7.85798 20.5931C8.85861 20.5931 9.6773 19.7744 9.6773 18.7738C9.6773 17.7732 8.85861 16.9545 7.85798 16.9545ZM16.9546 16.9545C15.954 16.9545 15.1444 17.7732 15.1444 18.7738C15.1444 19.7744 15.954 20.5931 16.9546 20.5931C17.9552 20.5931 18.7739 19.7744 18.7739 18.7738C18.7739 17.7732 17.9552 16.9545 16.9546 16.9545Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "19.8",
    cy: "4.19995",
    r: "3",
    fill: "#D72D5A"
  }));
};

exports["default"] = _default;